<template>
  <div class="app-container bg-f3f4f7" style="padding: 10px 20px 20px">
    <div class="flex content-top mb-10">
      <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
        <div class="tab-item active">
          <span class="bg-4-46b8b0"></span>
          账户列表
        </div>
      </div>
    </div>
    <div class="mb-10 flex">
      <div class="btn-24-bg-ff flex align-center mr-5" @click="onAdd">
        <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
        新增账户
      </div>
    </div>
    <div class="hr"></div>
    <div class="flex-1  h-0">
      <div class="h-100 flex-column">
        <div class="flex-1 h-0 mb-10">
          <div class="h-100">
            <erp-table :table-data="tableData" @change-current-row="changeCurrentRow" :column-data="columnData" @on-add-child="onAddChild"
                       ref="erpTable" @on-delete="onDelete" @on-modify="onModify" modify-method="on-modify" :is-edit="true"></erp-table>
          </div>
        </div>
        <move-vertical :max="560" :min="150" class="mtb-5" moveDom="bottom"></move-vertical>
        <div id="moveTop" class="flex-column" style="height: 220px">
          <div class="flex align-center">
            <div class="flex align-center mr-20 cursor pb-5 relative tabActive">
              <div class="mr-5 decoration-line"></div>
              <div class="font-bold font-16-46b8b0">账户子项</div>
            </div>
          </div>
          <div class="hr mb-10"></div>
          <div class="flex-1 h-0">
            <div class="h-100">
              <erp-table class="grayTable" :table-data="tableData2" :column-data="columnData2" ref="erpTable2" @on-modify="onModify"
                         modify-method="on-modify" @on-delete="onDelete" :is-edit="true"></erp-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErpTable from '../../components/ErpTable'
import Pagination from '../../components/Pagination'
import MoveVertical from '../../components/MoveVertical'

export default {
  name: 'bankAccountDefine',
  components: {ErpTable, Pagination, MoveVertical},
  data () {
    return {
      tableData: [],
      columnData: [
        {
          field: 'operate',
          title: '操作',
          width: '150',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '新增子项',
            methodName: 'on-add-child'
          }, {
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '删除',
            methodName: 'on-delete'
          }]
        }, {
          field: 'name',
          title: '账户名称',
          width: '200',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'money',
          title: '期初金额',
          width: '200',
          editType: 'number',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'remark',
          title: '说明',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ],
      currentRow: null,
      tableData2: [],
      columnData2: [
        {
          field: 'operate',
          title: '操作',
          width: '80',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '删除',
            methodName: 'on-delete'
          }]
        }, {
          field: 'name',
          title: '账户名称',
          width: '200',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'money',
          title: '期初金额',
          width: '200',
          editType: 'number',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'remark',
          title: '说明',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ]
    }
  },
  created () {
    this.getData(false, true)
  },
  mounted () {},
  methods: {
    changeCurrentRow (row) {
      this.currentRow = row
      this.getData(row.id)
    },
    onDelete (row) {
      let that = this
      this.$confirm(`此操作将永久删除"${row.name}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('account/deleteById', that.qs.stringify({id: row.id})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            if (row.parentId) {
              that.getData(row.parentId)
            } else {
              that.getData(false, that.currentRow.id === row.id)
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onAddChild (row) {
      let params = {
        companyId: this.$store.state.companyId,
        parentId: row.id
      }
      this.axios.post('account/save', params).then(res => {
        if (res.data.success) {
          this.$refs.erpTable2.insertAt(res.data.data, this.tableData2[0], 'name')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onAdd () {
      let params = {
        companyId: this.$store.state.companyId
      }
      this.axios.post('account/save', params).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.tableData[0], 'name')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onModify (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName]
      }
      this.axios.post('account/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getData (parentId, isRefresh) {
      let params = {
        companyId: this.$store.state.companyId
      }
      if (parentId) {
        params.parentId = parentId
      }
      this.axios.post('account/list', params).then(res => {
        if (res.data.success) {
          if (parentId) {
            this.tableData2 = res.data.data
          } else {
            this.tableData = res.data.data
          }
          if (isRefresh && this.tableData.length > 0) {
            this.getData(this.tableData[0].id)
            this.currentRow = this.tableData[0]
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #46b8b0;
      }
    }
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .tabActive {
    position: relative;
    &:after {
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      background-color: #46b8b0;
      left: 0;
      bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/bankAccountDefine.vue